/* eslint-disable */
import Vue from 'vue'
import Vuex from 'vuex'
import {
  getToken,
  setToken,
  getUser,
  setUser,
  removeUserInfo,
  setMenu,
  getMenu,
  setCompanyId,
  setQuotationTemplateId,
  getCompanyId,
  setBudgetId,
  getBudgetId,
  setBudgetGroupId,
  getBudgetGroupId,
  setLogin,
  setCompanyList,
  getCompanyList
} from '@/utils/auth'
import getters from './getters'

Vue.use(Vuex)

const state = {
  user: evil(getUser()),
  token: getToken(),
  menu: getMenu(),
  budgetId: getBudgetId(),
  budgetGroupId: getBudgetGroupId(),
  companyId: getCompanyId() || '0',
  API_URL_9010: 'http://121.40.34.125:9038',
  API_URL_9009: 'http://121.40.34.125:9039',
  companyList: getCompanyList() || [],
  quotationTemplate: {},
  isNotice: 0
}

const mutations = {
  SET_COMPANY_LIST: (state, data) => {
    state.companyList = data
  },
  SET_COMPANY_ID: (state, id) => {
    state.companyId = id
  },
  SET_BUDGET_ID: (state, id) => {
    state.budgetId = id
  },
  SET_BUDGET_GROUP_ID: (state, id) => {
    state.budgetGroupId = id
  },
  SET_USER: (state, user) => {
    state.user = user
  },
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_MENU: (state, menu) => {
    state.menu = menu
  },
  SET_NOTICE: (state, isNotice) => {
    state.isNotice = isNotice
  },
  SET_QUOTATION_TEMPLATE: (state, quotationTemplate) => {
    state.quotationTemplate = quotationTemplate
  },
  SET_QUOTATION_TEMPLATE_ID: (state, id) => {
    state.quotationTemplateId = id
  },
  REMOVE_USERINFO: (state) => {
    state.token = null
    state.user = null
    state.menu = null
    // state.openId = null
  }
}

const actions = {
  setCompanyList({
    commit
  }, data) {
    setCompanyList(data)
    commit('SET_COMPANY_LIST', data)
  },
  setQuotationTemplate({
    commit
  }, data) {
    commit('SET_QUOTATION_TEMPLATE', data)
  },
  setQuotationTemplateId({
    commit
  }, id) {
    setQuotationTemplateId(id)
    commit('SET_QUOTATION_TEMPLATE_ID', id)
  },
  setCompanyId({
    commit
  }, id) {
    setCompanyId(id)
    commit('SET_COMPANY_ID', id)
  },
  setBudgetId({
    commit
  }, id) {
    setBudgetId(id)
    commit('SET_BUDGET_ID', id)
  },
  setBudgetGroupId({
    commit
  }, id) {
    setBudgetGroupId(id)
    commit('SET_BUDGET_GROUP_ID', id)
  },
  setUser({
    commit
  }, user) {
    return new Promise((resolve, reject) => {
      setUser(user)
      commit('SET_USER', user)
      resolve()
    })
  },
  setToken({
    commit
  }, token) {
    setToken(token)
    commit('SET_TOKEN', token)
  },
  setMenu({
    commit
  }, menu) {
    setMenu(menu)
    commit('SET_MENU', menu)
  },
  setNotice({
    commit
  }, isNotice) {
    commit('SET_NOTICE', isNotice)
  },
  setLogin({
    commit
  }, isLogin) {
    setLogin(isLogin)
  },
  removeUser({
    commit
  }) {
    removeUserInfo()
    commit('REMOVE_USERINFO')
  }
}

const store = new Vuex.Store({
  state,
  mutations,
  getters,
  actions
})

function evil(fn) {
  let Fn = Function
  return new Fn('return ' + fn)()
}

export default store



// WEBPACK FOOTER //
// ./src/store/index.js